var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard2D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type5_x5F_beards"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x35_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#654023",
    d: "M411.7,353.8c-1.3-8,0.2-12-7.1-16c-5.6-3.1-14.7-6.1-20.8-4.8c-2.2,0.4-7.7,3.9-11.9,4.6 c-7.2,1.3-16.8,1.7-26.6-0.9c-6.2-1.7-7-3.5-9.6-4.6c-4-1.5-9.9-0.3-13.7,0.8c-6.4,1.8-15.7,4.6-19.4,9.6c-4.3,5.8-3.1,18-3,24.6 c0.1,9.2-1.7,15.4,0.7,22.1c1.7,4.6,5.8,8.8,10,12.7c8.3,7.6,16.7,13.5,30,14.8c16.2,1.6,40.8,2.2,54.5-6.9 c5.3-3.6,10.6-7.7,14.5-12.3c5.3-6.3,4.7-10.5,5.3-18C415.2,371.6,413,361.2,411.7,353.8z M404.6,352.4 c-0.3,4.4-0.9,11.9-2.3,16.2c-2,6.1-5,14.8-10,17.3c-4.8,2.4-9.5,5.2-15.1,3.3c-2.3-0.8-6.3-3.8-7.2-5.7c-1.1-2.4-0.3-5.3-3.6-6.8 c-3.5-1.6-14-1.5-17.5,0.3c-2.6,1.4-2.6,9.6-8.4,12.1c-4.6,2-12.8,0.4-17-1.3c-11.1-4.5-14-20.3-13-30c0.5-4.5,0.9-10.2,6.7-12.2 c5-1.7,12.7-1.9,18.1-2c6.4-0.1,11.1-0.3,17.5-0.3h5.5c12.1,0,27-0.6,38.9,0.9C404.1,345,405.1,345.9,404.6,352.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard2D);
export default __webpack_public_path__ + "static/media/man_beard_2d.fed67560a0e08a82330fff137bb55940.svg";
export { ForwardRef as ReactComponent };